import * as React from 'react';
import { Route } from 'react-router-dom';
import { PrivateRoute } from '../private-route/private-route';
import { AppRoute } from '../../types/app-route';

/* eslint-disable-next-line */
export interface AppRouterProps {
    routes: any[];
}

export function AppRouter(props: AppRouterProps) {
    return (
        <>
            {props.routes.map((route: AppRoute, i: React.Key) => {
                if (route.private) {
                    return <PrivateRoute key={i} {...route} />;
                } else {
                    return <Route key={i} {...route} />;
                }
            })}
        </>
    );
}
